/**
 * Polskie województwa i powiaty (TERYT/GUS — komplet stanu na 2024 r.).
 * Używane w kreatorze ujęcia jako lista wyboru z wyszukiwaniem (HTML datalist).
 *
 * Format powiatów: nazwa bez prefixu "powiat" — w UI pokazujemy "powiat warszawski zachodni"
 * przez format helpera. Miasta na prawach powiatu (M.st. Warszawa, Kraków itd.) są na liście
 * jednolitej z powiatami ziemskimi.
 */

export const VOIVODESHIPS: readonly string[] = [
  'dolnośląskie',
  'kujawsko-pomorskie',
  'lubelskie',
  'lubuskie',
  'łódzkie',
  'małopolskie',
  'mazowieckie',
  'opolskie',
  'podkarpackie',
  'podlaskie',
  'pomorskie',
  'śląskie',
  'świętokrzyskie',
  'warmińsko-mazurskie',
  'wielkopolskie',
  'zachodniopomorskie',
];

export const COUNTIES: Readonly<Record<string, readonly string[]>> = {
  'dolnośląskie': [
    'bolesławiecki', 'dzierżoniowski', 'głogowski', 'górowski', 'jaworski', 'karkonoski',
    'kamiennogórski', 'kłodzki', 'legnicki', 'lubański', 'lubiński', 'lwówecki', 'milicki',
    'oleśnicki', 'oławski', 'polkowicki', 'strzeliński', 'średzki', 'świdnicki', 'trzebnicki',
    'wałbrzyski', 'wołowski', 'wrocławski', 'ząbkowicki', 'zgorzelecki', 'złotoryjski',
    'Jelenia Góra (m.)', 'Legnica (m.)', 'Wałbrzych (m.)', 'Wrocław (m.)',
  ],
  'kujawsko-pomorskie': [
    'aleksandrowski', 'brodnicki', 'bydgoski', 'chełmiński', 'golubsko-dobrzyński',
    'grudziądzki', 'inowrocławski', 'lipnowski', 'mogileński', 'nakielski', 'radziejowski',
    'rypiński', 'sępoleński', 'świecki', 'toruński', 'tucholski', 'wąbrzeski', 'włocławski',
    'żniński', 'Bydgoszcz (m.)', 'Grudziądz (m.)', 'Toruń (m.)', 'Włocławek (m.)',
  ],
  'lubelskie': [
    'bialski', 'biłgorajski', 'chełmski', 'hrubieszowski', 'janowski', 'krasnostawski',
    'kraśnicki', 'lubartowski', 'lubelski', 'łęczyński', 'łukowski', 'opolski', 'parczewski',
    'puławski', 'radzyński', 'rycki', 'świdnicki', 'tomaszowski', 'włodawski', 'zamojski',
    'Biała Podlaska (m.)', 'Chełm (m.)', 'Lublin (m.)', 'Zamość (m.)',
  ],
  'lubuskie': [
    'gorzowski', 'krośnieński', 'międzyrzecki', 'nowosolski', 'słubicki', 'strzelecko-drezdenecki',
    'sulęciński', 'świebodziński', 'wschowski', 'zielonogórski', 'żagański', 'żarski',
    'Gorzów Wielkopolski (m.)', 'Zielona Góra (m.)',
  ],
  'łódzkie': [
    'bełchatowski', 'brzeziński', 'kutnowski', 'łaski', 'łęczycki', 'łowicki', 'łódzki wschodni',
    'opoczyński', 'pabianicki', 'pajęczański', 'piotrkowski', 'poddębicki', 'radomszczański',
    'rawski', 'sieradzki', 'skierniewicki', 'tomaszowski', 'wieluński', 'wieruszowski',
    'zduńskowolski', 'zgierski', 'Łódź (m.)', 'Piotrków Trybunalski (m.)', 'Skierniewice (m.)',
  ],
  'małopolskie': [
    'bocheński', 'brzeski', 'chrzanowski', 'dąbrowski', 'gorlicki', 'krakowski', 'limanowski',
    'miechowski', 'myślenicki', 'nowosądecki', 'nowotarski', 'olkuski', 'oświęcimski',
    'proszowicki', 'suski', 'tarnowski', 'tatrzański', 'wadowicki', 'wielicki',
    'Kraków (m.)', 'Nowy Sącz (m.)', 'Tarnów (m.)',
  ],
  'mazowieckie': [
    'białobrzeski', 'ciechanowski', 'garwoliński', 'gostyniński', 'grodziski', 'grójecki',
    'kozienicki', 'legionowski', 'lipski', 'łosicki', 'makowski', 'miński', 'mławski',
    'nowodworski', 'ostrołęcki', 'ostrowski', 'otwocki', 'piaseczyński', 'płocki', 'płoński',
    'pruszkowski', 'przasnyski', 'przysuski', 'pułtuski', 'radomski', 'siedlecki', 'sierpecki',
    'sochaczewski', 'sokołowski', 'szydłowiecki', 'warszawski zachodni', 'węgrowski',
    'wołomiński', 'wyszkowski', 'zwoleński', 'żuromiński', 'żyrardowski',
    'Ostrołęka (m.)', 'Płock (m.)', 'Radom (m.)', 'Siedlce (m.)', 'Warszawa (m.st.)',
  ],
  'opolskie': [
    'brzeski', 'głubczycki', 'kędzierzyńsko-kozielski', 'kluczborski', 'krapkowicki',
    'namysłowski', 'nyski', 'oleski', 'opolski', 'prudnicki', 'strzelecki', 'Opole (m.)',
  ],
  'podkarpackie': [
    'bieszczadzki', 'brzozowski', 'dębicki', 'jarosławski', 'jasielski', 'kolbuszowski',
    'krośnieński', 'leski', 'leżajski', 'lubaczowski', 'łańcucki', 'mielecki', 'niżański',
    'przemyski', 'przeworski', 'ropczycko-sędziszowski', 'rzeszowski', 'sanocki', 'stalowowolski',
    'strzyżowski', 'tarnobrzeski', 'Krosno (m.)', 'Przemyśl (m.)', 'Rzeszów (m.)', 'Tarnobrzeg (m.)',
  ],
  'podlaskie': [
    'augustowski', 'białostocki', 'bielski', 'grajewski', 'hajnowski', 'kolneński',
    'łomżyński', 'moniecki', 'sejneński', 'siemiatycki', 'sokólski', 'suwalski',
    'wysokomazowiecki', 'zambrowski', 'Białystok (m.)', 'Łomża (m.)', 'Suwałki (m.)',
  ],
  'pomorskie': [
    'bytowski', 'chojnicki', 'człuchowski', 'gdański', 'kartuski', 'kościerski', 'kwidzyński',
    'lęborski', 'malborski', 'nowodworski', 'pucki', 'słupski', 'starogardzki', 'sztumski',
    'tczewski', 'wejherowski', 'Gdańsk (m.)', 'Gdynia (m.)', 'Słupsk (m.)', 'Sopot (m.)',
  ],
  'śląskie': [
    'będziński', 'bielski', 'bieruńsko-lędziński', 'cieszyński', 'częstochowski', 'gliwicki',
    'kłobucki', 'lubliniecki', 'mikołowski', 'myszkowski', 'pszczyński', 'raciborski',
    'rybnicki', 'tarnogórski', 'wodzisławski', 'zawierciański', 'żywiecki',
    'Bielsko-Biała (m.)', 'Bytom (m.)', 'Chorzów (m.)', 'Częstochowa (m.)', 'Dąbrowa Górnicza (m.)',
    'Gliwice (m.)', 'Jastrzębie-Zdrój (m.)', 'Jaworzno (m.)', 'Katowice (m.)', 'Mysłowice (m.)',
    'Piekary Śląskie (m.)', 'Ruda Śląska (m.)', 'Rybnik (m.)', 'Siemianowice Śląskie (m.)',
    'Sosnowiec (m.)', 'Świętochłowice (m.)', 'Tychy (m.)', 'Zabrze (m.)', 'Żory (m.)',
  ],
  'świętokrzyskie': [
    'buski', 'jędrzejowski', 'kazimierski', 'kielecki', 'konecki', 'opatowski', 'ostrowiecki',
    'pińczowski', 'sandomierski', 'skarżyski', 'starachowicki', 'staszowski', 'włoszczowski',
    'Kielce (m.)',
  ],
  'warmińsko-mazurskie': [
    'bartoszycki', 'braniewski', 'działdowski', 'elbląski', 'ełcki', 'giżycki', 'gołdapski',
    'iławski', 'kętrzyński', 'lidzbarski', 'mrągowski', 'nidzicki', 'nowomiejski', 'olecki',
    'olsztyński', 'ostródzki', 'piski', 'szczycieński', 'węgorzewski',
    'Elbląg (m.)', 'Olsztyn (m.)',
  ],
  'wielkopolskie': [
    'chodzieski', 'czarnkowsko-trzcianecki', 'gnieźnieński', 'gostyński', 'grodziski',
    'jarociński', 'kaliski', 'kępiński', 'kolski', 'koniński', 'kościański', 'krotoszyński',
    'leszczyński', 'międzychodzki', 'nowotomyski', 'obornicki', 'ostrowski', 'ostrzeszowski',
    'pilski', 'pleszewski', 'poznański', 'rawicki', 'słupecki', 'szamotulski', 'średzki',
    'śremski', 'turecki', 'wągrowiecki', 'wolsztyński', 'wrzesiński', 'złotowski',
    'Kalisz (m.)', 'Konin (m.)', 'Leszno (m.)', 'Poznań (m.)',
  ],
  'zachodniopomorskie': [
    'białogardzki', 'choszczeński', 'drawski', 'goleniowski', 'gryficki', 'gryfiński',
    'kamieński', 'kołobrzeski', 'koszaliński', 'łobeski', 'myśliborski', 'policki',
    'pyrzycki', 'sławieński', 'stargardzki', 'szczecinecki', 'świdwiński', 'wałecki',
    'Koszalin (m.)', 'Szczecin (m.)', 'Świnoujście (m.)',
  ],
};
